import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import InventoryItems from '../../components/Admin/Inventory/InventoryItems';

/**
 * Inventory Items Page
 * Manage stock items in Inventory module
 */
export default function InventoryItemsPage() {
  return (
    <ModuleLayout>
      <InventoryItems />
    </ModuleLayout>
  );
}
